import * as React from 'react';

export default function SVGCaretRight(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      height="16"
      width="16"
      className="text-current fill-current"
    >
      <g clipPath="url(#a)">
        <path d="M13 8c0 .467-.2.867-.534 1.133L5 15.733c-.533.467-1.333.4-1.733-.133-.4-.533-.4-1.267.133-1.733l6.534-5.734c.066-.066.066-.133 0-.266L3.399 2.133A1.19 1.19 0 0 1 3.333.4 1.322 1.322 0 0 1 5.066.267L12.533 6.8c.266.333.466.733.466 1.2Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
